import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";

import { initialContactFilterData } from "../../../utils/initialData";
import { countNonMatchingEntries, handleDropdownClose } from "../../../utils/utils";
import ContactFilterData from "../../Contacts/components/ContactFilterData";

const ContactArchiveFilter = ({ filterData, onSetFilterData, onCallApiAgain }) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  const count = countNonMatchingEntries(filterData, initialContactFilterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    localStorage.setItem("filterData", JSON.stringify(filterData));
    onCallApiAgain(filterData);
    setIsSidebarOpen(false);
  };

  const saveSearchFilterData = {
    count: filterData?.count,
    start_count: filterData?.start_count,
    end_count: filterData?.end_count,
    };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      count: value?.count ?? "",
      start_count: value?.start_count ?? "",
      end_count: value?.end_count ?? "",
    };
    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(dataToSet);

    localStorage.setItem("searchfilterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    console.log('searchfilterData', dataToSet)
    onCallApiAgain(dataToSet);


  };


  return (
    <div>
      <SavedFilterComponent
        from="contact"
        filterType="basic"
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialContactFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={setSelectedSaveFilterId}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={setIsSidebarOpen}
      />


      <RightModal
        isOpen={isSidebarOpen}
        ref={dropdownRef}
        title="Filter"
        from="contact"
        desc="Enter Contact information."
        onFilter={handleFilter}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) => setSelectedSaveFilterId(value)}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
      >
        <ContactFilterData isSidebarOpen={isSidebarOpen} filterData={filterData} onSetFilterData={onSetFilterData} from="contactarchive" />
      </RightModal>
    </div>
  );
};

export default ContactArchiveFilter;
